import { NAME_PATTERN } from '../constants';
import { ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  NB_AUTH_OPTIONS,
  NbAuthResult,
  NbAuthService,
  NbAuthSocialLink,
} from '@nebular/auth';
import { NbDateService, NbDialogService, NbThemeService } from '@nebular/theme';
import { ReplaySubject, Subject } from 'rxjs';
import { distinctUntilChanged, filter, take, takeUntil } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { RolesData } from '../../../@core/interfaces/common/roles';
import { UserData } from '../../../@core/interfaces/common/users';
import { PatientRegistrationData } from '../../../@core/interfaces/patient-services/patient-registration';
import { DateService } from '../../../@theme/components/common/service/date.service';
import { InitUserService } from '../../../@theme/services/init-user.service';
import { getDeepFromObject } from '../../helpers';
import { NUMBERS_PATTERN } from '../constants';
import { PatientAppointmentData } from '../../../@core/interfaces/patient-services/patient-appointment';
import * as gender from './../../../data/gender.json';
import * as title from './../../../data/title.json';
import { INgxSelectOption } from 'ngx-select-ex';
import { HttpClient } from '@angular/common/http';
import { Location } from '@angular/common';
import { ToastrAppSrvcService } from '../../../_services/toastr-app-srvc.service';
import { WhatsappIntegration } from '../../../@core/interfaces/common/whatsappIntegration';
import { ReferralData } from '../../../@core/interfaces/masters/referral';
import { MailIntegration } from '../../../@core/interfaces/common/mailIntegration';
import { payerData } from '../../../@core/interfaces/patient-services/payer';
import { env } from 'process';
import { de } from 'date-fns/locale';
import * as departments from './../../../data/patient-portal-departments.json';
import { CountryService } from '../../../_services/patient-portal-country.service';
import { TenantRoleLoginService } from '../../../_services/tenant-role-login.service';

@Component({
  selector: 'ngx-patientportallogin',
  templateUrl: './patientportallogin.component.html',
  styleUrls: ['./patientportallogin.component.scss','../../../../assets/css/patient-portal.css']
})
export class PatientportalloginComponent implements OnInit, OnDestroy {
  protected readonly unsubscribe$ = new Subject<void>();
  private readonly tenantResolved$ = new ReplaySubject<void>(1);
  notUser:boolean=false;
  invalidMobile: boolean = false;
  loginForm: FormGroup;
  minLength: number = this.getConfigValue('forms.validation.password.minLength');
  maxLength: number = this.getConfigValue('forms.validation.password.maxLength');
  redirectDelay: number = this.getConfigValue('forms.login.redirectDelay');
  showMessages: any = this.getConfigValue('forms.login.showMessages');
  strategy: string = this.getConfigValue('forms.login.strategy');
  socialLinks: NbAuthSocialLink[] = this.getConfigValue('forms.login.socialLinks');
  rememberMe = this.getConfigValue('forms.login.rememberMe');
  isEmailRequired: boolean = this.getConfigValue('forms.validation.email.required');
  isPasswordRequired: boolean = this.getConfigValue('forms.validation.password.required');
  isTenantIdRequired: boolean = this.getConfigValue('forms.validation.tenantId.required');
  isUserNameRequired: boolean = this.getConfigValue('forms.validation.userName.required');
  isMobileNumberRequired: boolean = this.getConfigValue('forms.validation.fullName.required');
  genderList: string[] = (gender as any).default;
  titleList: any = (title as any).default;
  isNewPatientLink: boolean = false;
  isNewDoctorLink: boolean = false;
  messages: any[];
  errors: any[];
  submitted: boolean;
  user: any; 
  loginResult: any;
  data: Array<any>=[];
  loginUserAuthorized: boolean=false;
  accessToken: string;
  loginData: any;
  OTPid: any;
  phoneNumber: any;
  smscontent: string;
  emailcontent:string;
  sendthroughsms: boolean;
  templateData: any;
  isOtpDia: boolean;
  otpForm: FormGroup;
  mobileVerifyPopUp: boolean=false;
  isSuccess: boolean=false;
  isFailure: boolean=false;
  // Surfaces the backend's specific message (e.g. rate-limit/cooldown text on send failures,
  // or the verify failure reason) instead of a single hardcoded "Incorrect OTP" string.
  otpErrorMessage: string = 'Incorrect OTP';
  // Send (not verify) failures - shown on the mobile-number step, since the OTP-entry popup
  // is never opened if the OTP couldn't be sent in the first place.
  otpSendFailed: boolean = false;
  resetForm: FormGroup;
  passWordChange: boolean=false;
  bookingPlatFormApp: FormGroup;
  isForgotPassword: boolean;
  isUserLogin: boolean;
  resetMobileNum: any;
  isResetComp: boolean;
  userAlreadyExists: boolean;
  customer:boolean=true;
  isSubmitted: boolean=false;
  isAppointmentSaved: boolean;
  invalidbookingPlatFormAppForm: boolean;
  get fullName() { return this.loginForm.get('fullName'); }
  get password() { return this.loginForm.get('password'); }
  isLogin:boolean = true;
  forgetPass:boolean=false;
  // "Use Passport Number instead" toggle on the tenant patient login (same as care-login).
  usePassportNumber: boolean = false;
  togglePassportNumber(): void {
    this.usePassportNumber = !this.usePassportNumber;
  }
  // Forgot-password OTP calls target the tenant being logged into on the tenant login, else the virtual tenant.
  get otpTenantId(): string {
    return this.tenantAlias ? this.dynamicTenantId : environment.virtualTenant;
  }
  userName:string='';
  userMobileNumber:string='';
  selectedCC:string='';
  @ViewChild("digit1") d1Element: ElementRef;
  @ViewChild("digit2") d2Element: ElementRef;
  @ViewChild("digit3") d3Element: ElementRef;
  @ViewChild("digit4") d4Element: ElementRef;
  @ViewChild("digit5") d5Element: ElementRef;
  @ViewChild("digit6") d6Element: ElementRef;
  @ViewChild("verifybtn") verifyBtnElement: ElementRef;
  tenatId = environment.patientTenantId;
  cusId = environment.patientCusID;
  branchId=environment.patientBranchId
  signUp :boolean = false;
  patientDetails:Array<any>=[];
  patientLists:Array<any>=[];
  userList:Array<any>=[];
  placeholder:string="Select";
  maxDobDate:Date;
  newPassFlag:boolean=false;
  countryCodeDropDownLists: Array<any> = [];
  mobileMinlength: number = 10;
  mobileMaxlength: number = 10;
  page:string="location"; // "signup" or "location"
  appointmentBookingPath:string;
  isAppointmentBooking:boolean=false;
  isPatientDoc:boolean=false;
  countryDetail:any={};
  countryName:string;
  nearByCity:string;
  nearByRegion:string;
  lastFourDigits:any;
  cc = '';
  isAssesment:boolean=false;
  assesmentData:any={};
  assesPopUpForAgeMismatch:boolean=false;
  
  whatsappcontent: string;
  whatsAppToken:string=''
  whatsAppUrl:string=''
  dialogRef: any = null;
  @ViewChild('whatsappDialog') whatsappDialog: TemplateRef<any>;
  towhatsappnumber: string;
  pageName:string = 'registration';
  patRegId:string = '';
  superAdminTenant:any={};
  patientEmail:string;
  lastCountryCode: string | null = null;

  showMore:boolean=false;
  departments:any = (departments as any).default;

  // WellSpring Login support: reused by this same component when routed via /auth/well-spring-login[/:tenantId].
  wellSpringAppFlag: boolean = false;
  tenantAlias: string | null = null;
  dynamicTenantId: string;
  dynamicBranchId: string;
  customerName: string;
  countryId: string;
  customerTenantLogo: string = 'assets/images/caresphere/wellspring.jpg';
  userType: string = ''; // 'doctor' | 'patient' | 'care-navigator' | 'reviewer' - tenant-based "Second Opinion" role selection
  employeeLoginForm: FormGroup;
  // Set when this login page was reached via the Care Navigator/Reviewer invite URL
  // (well-spring-login/:tenantId/care-navigator|reviewer) - used to send the user back to
  // their own role-specific login on logout, session expiry, or a failed login attempt,
  // instead of the generic Patient/Doctor role-selector.
  employeeRoleUrlSuffix: string | null = null;
  get showWebsite(): boolean {
    return this.wellSpringAppFlag && !!this.tenantAlias && this.userType === '' && !this.employeeRoleUrlSuffix;
  }
  siteStartPage: string | null = null;
  get showSiteHeader(): boolean {
    return (this.page === 'signup' || this.page === 'tenant-login') && !!this.tenantAlias
      && (this.userType === 'patient' || this.userType === 'doctor' || this.userType === 'care-navigator');
  }
  onSiteSignup(): void {
    this.selectUserType("patient");
    this.isLogin = false;
    this.isSubmitted = false;
    this.onCreateAccount();
  }
  onSitePageSelect(slug: string): void {
    if (this.employeeRoleUrlSuffix) {
      this.router.navigate(['/auth/well-spring-login', this.tenantAlias], { queryParams: { page: slug } });
      return;
    }
    this.siteStartPage = slug;
    this.selectUserType('');
    setTimeout(() => this.siteStartPage = null);
  }
  get isEmployeeRole(): boolean {
    return this.userType === 'care-navigator' || this.userType === 'reviewer';
  }
  // Set by redirectAfterLogin()'s onUnauthorized callback when a real employee login
  // succeeds (correct credentials) but the employee isn't a Care Navigator (JobCategoryId
  // != 49 in Employee_Mst) - see TenantRoleLoginService.redirectEmployeeRole().
  employeeRoleError: string = '';
  private secondOpinionTenant = false;
  siteLogoSrc: string | null = null;
  siteLogoPending = true;
  get siteLogoAlt(): string {
    return this.secondOpinionTenant ? 'Second Opinion' : (this.customerName || 'WellSpring');
  }
  // Show/hide toggle for the Care Navigator sign-in's password field (eye icon) - only
  // rendered/used for that role today, per the dedicated Care Navigator sign-in redesign.
  showEmployeePassword: boolean = false;
  toggleEmployeePasswordVisibility(): void {
    this.showEmployeePassword = !this.showEmployeePassword;
  }
  // Read fresh (not snapshotted) so it picks up resolveTenant()'s async
  // tenantType==='secondopinion' write - bound to ngx-patientportalheaders below so its
  // Region selector shows up reactively once the tenant resolves.
  get secondOpinionFlag(): boolean {
    return localStorage.getItem('SecondOpinionFlag') === 'true';
  }

  // Second Opinion registration is 18+ only: the DOB calendar stops at today minus 18 years, and a
  // typed/pasted DOB that is under 18 fails validation (underAge). Other tenants keep today as the max.
  get adultMaxDob(): Date {
    const d = new Date();
    d.setFullYear(d.getFullYear() - 18);
    d.setHours(23, 59, 59, 999);
    return d;
  }

  get dobMaxDate(): Date {
    return this.secondOpinionFlag ? this.adultMaxDob : this.maxDobDate;
  }

  private adultDobError(value: any): { underAge: true } | null {
    if (!value || !this.secondOpinionFlag) { return null; }
    const dob = new Date(value);
    return !isNaN(dob.getTime()) && dob > this.adultMaxDob ? { underAge: true } : null;
  }

  constructor(
    protected service: NbAuthService,
    @Inject(NB_AUTH_OPTIONS) protected options = {},
    protected cd: ChangeDetectorRef,
    protected themeService: NbThemeService,
    private fb: FormBuilder,
    private patSrvc: PatientRegistrationData, 
    protected router: Router,
  private route: ActivatedRoute,protected rolesService: RolesData,protected userService: UserData,public DatService:DateService,protected initUserService: InitUserService,private getDrAppointmentService: PatientAppointmentData,protected dateService: NbDateService<Date>,protected http:HttpClient,private patAptSrv: PatientAppointmentData,private location: Location,
  private phySrvc: payerData,private toaster: ToastrAppSrvcService,protected whatsappService : WhatsappIntegration,protected dialogService: NbDialogService,protected referralService:ReferralData,protected MailService : MailIntegration, private countryService: CountryService, private tenantRoleLoginService: TenantRoleLoginService) { }

    get apiUrl(): string {
      return environment.apiUrl;
     }

  ngOnInit(): void {
    localStorage.clear();
    document.body.classList.add('patient-portal');
    // this.fetchDeptFromVirtual();
    this.isNewPatientLink = false;

    this.wellSpringAppFlag = !!this.route.snapshot.data['wellSpringApp'];
    this.tenantAlias = this.route.snapshot.paramMap.get('tenantId');
    this.siteStartPage = this.route.snapshot.queryParamMap.get('page');
    // Persisted so pages/menu/layout/logout can tell a WellSpring App session apart
    // from a plain patient-portal or legacy CareLoginComponent tenant session.
    localStorage.setItem('WellSpringAppFlag', String(this.wellSpringAppFlag));
    // "Second Opinion" flow flag: derived from the resolved tenant's tenantType (see
    // resolveTenant() below, which sets it to 'secondopinion' from the auth/validtenant
    // response) - defaults to false until that resolves. Drives the Home/Second-Opinion nav
    // row, the country selector in ngx-well-spring-header, and the Care Navigator/Reviewer/
    // second-opinion-patient sidebar menus.
    localStorage.setItem('SecondOpinionFlag', 'false');
    // Static fallback only - used if no dynamic logo comes back from the API below
    // (or there's no tenant/virtual-tenant banner configured at all). Which asset to
    // fall back to depends on which app this login screen is actually for.
    this.customerTenantLogo = this.wellSpringAppFlag
      ? 'assets/images/caresphere/wellspring.jpg'
      : 'assets/images/Ziloy/ziloy-logo.png';
    if (this.tenantAlias) {
      // Tenant-based WellSpring Login: skip the marketing landing/onboarding flow
      // entirely and resolve the tenant the same way CareLoginComponent does.
      this.page = 'tenant-login';
      localStorage.setItem('tenantAlias', this.tenantAlias);
      // Care Navigator / Reviewer come from a dedicated invite URL
      // (well-spring-login/:tenantId/care-navigator|reviewer), not from the in-page role
      // selector - pre-select the role so the card grid never shows for these links.
      const urlEmployeeRole = this.route.snapshot.data['employeeRole'];
      if (urlEmployeeRole === 'care-navigator' || urlEmployeeRole === 'reviewer') {
        this.userType = urlEmployeeRole;
        this.employeeRoleUrlSuffix = urlEmployeeRole;
        localStorage.setItem('employeeRoleUrlSuffix', urlEmployeeRole);
      }
    } else if (this.wellSpringAppFlag) {
      // No-tenant WellSpring (plain OTP flow) has no real tenant to resolve, but
      // still books against the shared virtual tenant/branch (see the
      // patientregistrationmst search further below) - try that virtual tenant's
      // own configured banner logo the same way a real tenant's is fetched, rather
      // than only ever showing the static asset.
      this.tenantRoleLoginService.getTenantBanner(environment.virtualTenant, environment.virtualBranch)
        .pipe(takeUntil(this.unsubscribe$)).subscribe((logo) => {
          if (logo) {
            this.customerTenantLogo = logo;
            this.cd.detectChanges();
          }
        });
    }
    const mobileNumberValidators = [
      Validators.pattern(NUMBERS_PATTERN),
    ];
    const passwordValidators = [
      Validators.pattern(NUMBERS_PATTERN),
      Validators.minLength(8),
      Validators.maxLength(16),
    ];
    this.resetForm = this.fb.group({
      password: this.fb.control('',[Validators.required,Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\\d$@$!%*?&]{8,}$')]),
      confirmPassword : this.fb.control('',[Validators.required,Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\\d$@$!%*?&]{8,}$')])
    })
    this.bookingPlatFormApp = this.fb.group({
      mobile: this.fb.control(null,[Validators.required]),
      firstName: this.fb.control(null,[Validators.required,Validators.pattern(NAME_PATTERN)]),
      lastName: this.fb.control(null,[Validators.pattern(NAME_PATTERN)]),
      dob: this.fb.control(null,[Validators.required, (c: any) => this.adultDobError(c.value)]),
      gender:this.fb.control(null,[Validators.required]),
      title:this.fb.control(null,[Validators.required]),
      pass:this.fb.control(null,[Validators.required,Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\\d$@$!%*?&]{8,}$')]),
      confirmPass:this.fb.control(null,[Validators.required,Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\\d$@$!%*?&]{8,}$')]),
      mobileCountryCode: this.fb.control(null,[Validators.required]),
      email: this.fb.control(null, [ Validators.email, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]),
    });

    this.loginForm = this.fb.group({
      fullName: this.fb.control('', [...mobileNumberValidators]),
      password: this.fb.control('',  ),
      rememberMe: this.fb.control(''),
      tenantId: this.fb.control(''),
      branchId: this.fb.control(''),
      mobileCountryCode: this.fb.control('',[Validators.required])
    });
    // Employee-style login (Care Navigator / Reviewer): Employee ID or work email + password,
    // no mobile-number/country-code validators - distinct from the doctor/patient loginForm above.
    this.employeeLoginForm = this.fb.group({
      employeeIdOrEmail: this.fb.control('', [Validators.required]),
      password: this.fb.control('', [Validators.required]),
      tenantId: this.fb.control(''),
      branchId: this.fb.control(''),
    });
    localStorage.setItem('responseTenantId', this.tenatId);

    var regID=localStorage?.getItem("regID");
    if(regID!=null){
      // this.router.navigateByUrl("pages/patient-portal/landing/"+regID);
    }
    this.otpForm = this.fb.group({
      digit1: this.fb.control('', [Validators.pattern('^[0-9-]+$'), Validators.maxLength(1), Validators.minLength(1)]),
      digit2: this.fb.control(''),
      digit3: this.fb.control(''),
      digit4: this.fb.control(''),
      digit5: this.fb.control(''),
      digit6: this.fb.control(''),
    });
    this.otpForm.get("digit1").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d2Element.nativeElement.focus());
    this.otpForm.get("digit2").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d3Element.nativeElement.focus());
    this.otpForm.get("digit3").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d4Element.nativeElement.focus());
    this.otpForm.get("digit4").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d5Element.nativeElement.focus());
    this.otpForm.get("digit5").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d6Element.nativeElement.focus());
    this.otpForm.get("digit6").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.verifyBtnElement.nativeElement.focus());
  
    this.maxDobDate = this.dateService.addDay(this.dateService.today(), 0);

    this.countryService.countryCode$.pipe(distinctUntilChanged()).subscribe(code => {
      if (this.lastCountryCode !== code) {
        this.lastCountryCode = code;
        this.cc = code;
        if(this.page == 'signup'){
          this.page='';
          this.onClickProfile();
        }
      }
    });

    if (this.tenantAlias) {
      this.tenantRoleLoginService.resolveTenant(this.tenantAlias).pipe(takeUntil(this.unsubscribe$)).subscribe({
        next: (resolved) => {
          this.dynamicTenantId = resolved.tenantId;
          this.dynamicBranchId = resolved.branchId;
          this.customerName = resolved.customerName;
          this.countryId = resolved.countryId;
          this.secondOpinionTenant = resolved.tenantType === 'secondopinion';
          localStorage.setItem('SecondOpinionFlag', String(this.secondOpinionTenant));
          if (this.secondOpinionTenant) {
            this.siteLogoSrc = 'assets/images/caresphere/so-logo.svg';
            this.siteLogoPending = false;
          }
          this.tenantResolved$.next();
          this.loginForm.get('mobileCountryCode')?.setValue(resolved.countryId);
          this.tenantRoleLoginService.getTenantBanner(this.dynamicTenantId, this.dynamicBranchId)
            .pipe(takeUntil(this.unsubscribe$)).subscribe((logo) => {
              if (logo) {
                this.customerTenantLogo = logo;
                if (!this.secondOpinionTenant) { this.siteLogoSrc = logo; }
              }
              this.siteLogoPending = false;
              this.cd.detectChanges();
            }, () => {
              this.siteLogoPending = false;
              this.cd.detectChanges();
            });
        },
        error: () => {
          this.errors = ['Unable to resolve tenant. Please try again later.'];
          this.siteLogoPending = false;
          this.tenantResolved$.next();
        },
      });
    }
  }

  // Mirrors CareLoginComponent.selectUserType() - tenant-based "Second Opinion" role selection
  // (Patient / Doctor / Care Navigator / Reviewer).
  selectUserType(type: string): void {
    this.userAlreadyExists = false;
    this.loginForm.reset();
    this.employeeLoginForm.reset();
    this.loginResult = null;
    this.messages = [];
    this.errors = [];
    this.employeeRoleError = '';
    // Leave any Forgot Password / OTP / reset-password step behind, so picking a role (or going
    // Back and picking one again) always lands on that role's sign-in form.
    this.isLogin = true;
    this.forgetPass = false;
    this.newPassFlag = false;
    this.mobileVerifyPopUp = false;
    this.notUser = false;
    this.invalidMobile = false;
    this.otpSendFailed = false;
    this.usePassportNumber = false;
    this.userType = type;
  }

  ngOnDestroy() {
    document.body.classList.remove('patient-portal');
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  
  onSignupClose(data: any): void   {
    this.isNewPatientLink = false;
    
  }
  get fval() { return this.bookingPlatFormApp.controls; }
  get loginval() {return this.loginForm.controls }

  onDocotrSignupClose(data: any): void   {
    this.isNewDoctorLink = false;    
  }
  getConfigValue(key: string): any {
  
    return getDeepFromObject(this.options, key, null);
  }


  newPatient()
  {
    this.isNewPatientLink = true;
  }

  onVerify() {

    let otp = "";
    otp += this.otpForm.get('digit1').value;
    otp += this.otpForm.get('digit2').value;
    otp += this.otpForm.get('digit3').value;
    otp += this.otpForm.get('digit4').value;
    otp += this.otpForm.get('digit5').value;
    otp += this.otpForm.get('digit6').value;
    if (otp != "") {
      // SECURITY: OTP verification is performed entirely server-side. The frontend only
      // forwards the entered code and mobile number; it never compares against a locally-held
      // OTP value (this.OTPid no longer holds the OTP itself - see getotpsms()).
      const verifyPayload = {
        otpCode: otp,
        userMobileNumber: this.phoneNumber
      };
      this.rolesService.create(`${this.apiUrl}/patientportalnewuser/${this.otpTenantId}/verifyotp`, verifyPayload).pipe(takeUntil(this.unsubscribe$)).subscribe((result: any) => {
        if (result && result.code === 200) {
          this.isSuccess = true;
          this.isFailure = false;
          this.isLogin=false;
          this.forgetPass=false;
          this.newPassFlag=true;
          this.mobileVerifyPopUp = false;
        }
        else {
          this.otpErrorMessage = (result && result.status) || 'Incorrect OTP';
          this.isFailure = true;
          this.isSuccess = false;
        }
      }, (error) => {
        this.otpErrorMessage = (error && error.error && error.error.status) || 'Incorrect OTP';
        this.isFailure = true;
        this.isSuccess = false;
      });
    }
  }

  otpFormClose(){
    this.mobileVerifyPopUp=false; 
    this.otpForm.reset({
      digit1: '',
      digit2: '',
      digit3: '',
      digit4: '',
      digit5: '',
      digit6: '',
    });
  }

  gotoBooking(routingPath){

    if( Array.isArray(routingPath) ){
      routingPath=routingPath.join(',');
    }
    this.appointmentBookingPath=routingPath;
    this.isAppointmentBooking = true;
    if(routingPath == 'doc') this.isPatientDoc = localStorage.getItem('isPatientDoc') === 'true';
    this.isAssesment=false;
  }
  gotoFindDoctor(){
    localStorage.setItem('isPatientDoc', 'true');
  this.gotoBooking('doc');
  }

  verifyMobileIsexist() {
    this.errors = [];
    this.notUser = false;
    this.otpSendFailed = false;
    // Forgot password: reject an empty / non-numeric / wrong-length mobile number before any API call.
    const enteredMobile = (this.loginForm.get("fullName").value || "").toString().trim();
    const minLen = this.tenantAlias ? 7 : this.mobileMinlength;
    const maxLen = this.tenantAlias ? 15 : this.mobileMaxlength;
    this.invalidMobile = !/^[0-9]+$/.test(enteredMobile) || enteredMobile.length < minLen || enteredMobile.length > maxLen;
    if (this.invalidMobile) { return; }
      let data={
        "PatientMobile":this.loginForm.get('fullName').value,
        "countryId":this.loginForm.get('mobileCountryCode')?.value
      }
      this.lastFourDigits=this.loginForm.get('fullName').value?.toString().slice(-4);
      this.getDrAppointmentService.searchList(`bookingPlatform/checkIsPatientExists`, data).pipe(takeUntil(this.unsubscribe$)).subscribe(returnData => {
        if(!!returnData?.user){  
          this.notUser=false;
          this.phoneNumber = this.loginForm.get('fullName').value;
          if(!!this.phoneNumber && this.phoneNumber!=undefined){
        
          this.userService.getBranchList(`users/mobile/${this.phoneNumber}/${this.otpTenantId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
            if(!!data){
              this.getotpsms();
            } else {
              this.notUser = true;
            }
          }, (error) => {
            // No account for this number under this tenant (or the lookup failed) - show it instead of doing nothing.
            this.notUser = true;
          }, () => {
          
          });
          }
        }else{
          this.notUser=true;

        }

      }, () => {
        this.notUser = true;
      })
       

  }
  
  verifyPass(event){
    
    event.target.disabled = true;
    if(this.resetForm.valid && (this.resetForm.get('password').value == this.resetForm.get('confirmPassword').value)){
      const det = {
        Password: this.resetForm.get('password')?.value,
        ConfirmPassword: this.resetForm.get('password')?.value,
        MobileNumber: this.phoneNumber
      }
      this.http.post(environment.apiUrl+'/auth/updatePassword',det).pipe(takeUntil(this.unsubscribe$)).subscribe(()=>{
        this.resetForm.reset();
        event.target.disabled = false;
        this.newPassFlag=false;
        this.passWordChange = true;
        setTimeout(()=>{this.passWordChange = false;},4000)
        this.isLogin=true;
        this.isSuccess = true;
      });

    }else{
      event.target.disabled = false;
    }
  }

  getotpsms(){
    let data = {
      "headers": {
        "Accept": "application/vnd.ezovion.hateoas+json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    }
    // SECURITY: the backend no longer returns the OTP value, only { success, message }.
    // Verification of the user-entered code happens entirely server-side in onVerify().
    this.otpSendFailed = false;
    this.rolesService.create(`${this.apiUrl}/patientportalnewuser/${this.otpTenantId}/sendotp/${this.phoneNumber}`,data).pipe(takeUntil(this.unsubscribe$)).subscribe((response: any) => {
     // Non-secret marker only - indicates an OTP has been sent, never the OTP value itself.
     this.OTPid = response && response.success ? 'sent' : null;
    }, (error) => {
      // Send failed (e.g. rate-limit/cooldown 429) - surface the backend's message on the
      // mobile-number step rather than silently doing nothing, since the OTP-entry popup
      // below never opens in this case.
      this.otpSendFailed = true;
      this.otpErrorMessage = (error && error.error && error.error.message) || 'Unable to send OTP. Please try again.';
    }, () => {
      this.mobileVerifyPopUp = true;
    });
  }

  getTenantByCountryCode(){
        this.phySrvc.list(`${this.apiUrl}/tenants/${environment.virtualTenant}/tenantbranch/getSuperAdminByCountry?CountryCode=${this.cc}`).subscribe(data => {
      if(data.details){
        this.superAdminTenant = data.details
      }

    },(error)=>{if(error.status == 401) this.router.navigateByUrl('/auth/patient-portal') },()=>{})
  }

  checksmspossibility(option){
    this.getTenantByCountryCode()
    let templateData;
    let istemplatepurchase;
    let patientDetails = {name: this.userName, mobileNumber: this.userMobileNumber, countryCode:this.cc, regId:'', email:this.patientEmail}
    this.rolesService.list(`PaymentGatewayConfiguration/GetCommDetByTemplateNamePatientportal?virtualTenantId=${environment.virtualTenant}&virtualBranchId=${environment.virtualBranch}&templateName=${this.pageName + '-' + option}&countryCode=${this.cc}`).subscribe((data:any) => {
      if(!!data?.details){
          istemplatepurchase = data?.details
        if(istemplatepurchase.smsFlag){
            if(istemplatepurchase.smsContent){   
              // this.smscontent='Dear Nandhini, Your registration with our hospital on 15-oct has been successfully completed. Your registration no is 1234 Call us at 785878878787 to make appointments or for any other assistance. Regards, Team Ezovion'  
                                     
              this.smscontent=istemplatepurchase.smsContent.replace((new RegExp("{patientname}", "g")),this.userName)
              .replace((new RegExp("{hospitalphonenumber}", "g")),'7858788787')
              .replace((new RegExp("{hospitalname}", "g")),'Ezovion')
              .replace((new RegExp("{regdate}", "g")),'15-oct-2025')
              .replace((new RegExp("{regno}", "g")),'1234')
              .replace((new RegExp("{hospitalbranch}", "g")), 'Chennai') 
            }
              if(istemplatepurchase.creditBalance > 0){
                this.sendSMS(patientDetails,istemplatepurchase,option);
              }else{
                this.toaster.ForDanger('SMS Credit Balance is 0');
              }
        }

      if (istemplatepurchase.whatsappFlag) {

          if(istemplatepurchase?.whatsappContent){
              const matches = istemplatepurchase?.whatsappContent?.match(/{.*?}/g)?.join(" , ") || [];
              // this.whatsappcontent='Dear Nandhini, Your registration on 15-oct has been successfully completed. Your registration no is 1234. Call us at 000409089 to make appointments or for any other assistance. Regards, Ezovion Team'
              this. whatsappcontent = istemplatepurchase?.whatsappContent.replace((new RegExp("{patientname}", "g")),this.userName)
              .replace((new RegExp("{hospitalphonenumber}", "g")),'7858788787')
              .replace((new RegExp("{hospitalname}", "g")),'Ezovion')
              .replace((new RegExp("{regdate}", "g")),'15-oct-2025')
              .replace((new RegExp("{regno}", "g")),'1234')
              .replace((new RegExp("{hospitalbranch}", "g")), 'Chennai')

              const WithoutReplace = matches?.replace((new RegExp("{patientname}", "g")),this.userName)
              .replace((new RegExp("{hospitalphonenumber}", "g")),'7858788787')
              .replace((new RegExp("{hospitalname}", "g")),'Ezovion')
              .replace((new RegExp("{regdate}", "g")),'15-oct-2025')
              .replace((new RegExp("{regno}", "g")),'1234')
              .replace((new RegExp("{hospitalbranch}", "g")), 'Chennai')
              const placeholders = WithoutReplace?.split(",")?.map(s => s.trim())?.map(s => ({ text: s })) || ""; 

              if(istemplatepurchase?.whatsappCreditBalance > 0){

                this.whatsAppToken = istemplatepurchase?.businessAppTokenNo
                this.whatsAppUrl = istemplatepurchase?.whatsappApiUrl
                
                const whatsappSentItems = {
                  
                  phone : this.cc.replace(/\+/g, "") + this.userMobileNumber, 
                  templateName : istemplatepurchase?.whatsappTemplateName || '',
                  parameters : placeholders,
                  languageCode : istemplatepurchase?.whatsappTemplateLan

                }

                if(whatsappSentItems.phone && whatsappSentItems.templateName && whatsappSentItems.parameters && this.whatsAppToken && this.whatsAppUrl){
                  this.whatsappService.sendMessage(whatsappSentItems , this.whatsAppToken , this.whatsAppUrl).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
                    if(data){
                        const whatsAppPostData = {
                          "branchId":this.superAdminTenant.branchId,
                          "tenantId":this.superAdminTenant.tenantId,
                          "dateTime": new Date(),
                          // "createdby": parseInt(localStorage.getItem("userId")),
                          "mobileNumber": whatsappSentItems.phone,
                          // "referencenum": paticentDetails.regNum ?? 0,
                          "referencefrom":this.pageName + '-' + option,
                          "message": this.whatsappcontent,
                          "smsUnit":1,
                          "senderId":null,
                          "status":"Sent",
                          "templateId":null,
                          "createdIp":null,
                          "createddate": new Date(),
                          "whatsappReferenceId":data?.messages[0]?.id ?? ''
                        }
                        this.rolesService.create(`${this.apiUrl}/smstrackingdet/${environment.virtualTenant}/${environment.virtualBranch}/sendWhatsapp`,whatsAppPostData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
                          this.toaster.ForSuccess('Whatsapp Message Send Sucessfully');
                        },(error)=>{if(error.status == 401) this.router.navigateByUrl('/auth/patient-portal')},()=>{})
                      }else{
                        this.toaster.ForDanger('Whatsapp Message Send Unsucessfull');
                      }
                      })
                    }else{
                      // istemplatepurchase = templateData.whatsApp.purchasedTemplateDet.filter(x =>x.commonTemplateMstDet.templateName.toLocaleLowerCase() == this.pageName+'-'+option)
                      // if(istemplatepurchase?.length>0){
                      //   if(templateData.whatsApp.smsCreditCount>0 && istemplatepurchase.length-1>-1){
                          this.towhatsappnumber=patientDetails.mobileNumber;
                          this.dialogRef = this.dialogService.open(
                            this.whatsappDialog,
                            {
                              closeOnBackdropClick: false,
                              closeOnEsc: false
                            });
                      // }
                      // }
                    }                     

              }else{
                  this.toaster.ForDanger('Whatsapp Credit Balance is 0');
              }
          }       
      }      
      }
        if(istemplatepurchase.emailFlag && patientDetails.email){
            if(istemplatepurchase.emailContent){            
              this.emailcontent=istemplatepurchase.emailContent.replace((new RegExp("{patientname}", "g")),this.userName)
              .replace((new RegExp("{hospitalphonenumber}", "g")),'7858788787')
              .replace((new RegExp("{hospitalname}", "g")),'Ezovion')
              .replace((new RegExp("{regdate}", "g")),'15-oct-2025')
              .replace((new RegExp("{regno}", "g")),'1234')
              .replace((new RegExp("{hospitalbranch}", "g")), 'Chennai')
            }
    
              if(istemplatepurchase.emailCreditBalance > 0){

                const loadData = {
                  "Content" : this.emailcontent , 
                  "isTemplate" : istemplatepurchase , 
                  "Branch" : {name:this.superAdminTenant.branchId} ,
                  "Patient" : patientDetails , 
                  "Provider" : istemplatepurchase?.emailProviderName ,
                  "Subject" : `Registration Email From Ezovion`,
                  "HtmlContact" : `<html><head><title></title></head><body><p>${this.emailcontent}</p></body></html>`
                   
                }
                if(patientDetails.email){                          
               this.MailService.sendMailMessage(loadData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
                if(data.response_type === "success"){

                        const whatsAppPostData = 
                        {
                          "referenceFrom": this.pageName+'-'+option,
                          "referenceNum": patientDetails.regId ?? 0,
                          "createdDateTime": new Date(),
                          // "createdBy": parseInt(localStorage.getItem("userId")),
                          "receiverEmailId": patientDetails.email,
                          "emailMessage": this.emailcontent,
                          "emailUnit": 1,
                          "senderEmailId": istemplatepurchase.emailSenderMail,
                          "sentStatus": "Pending",
                          "tenantId": this.superAdminTenant.tenantId,
                          "branchId": this.superAdminTenant.branchId,
                          "emailConfigId": istemplatepurchase.emailConfigId
                        }

                        this.rolesService.create(`${this.apiUrl}/emailConfigMst/PostEmailTrackingDet`,whatsAppPostData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
                    this.toaster.ForSuccess('Email Message Send sucessfull');                          
                        }, (error) => {
                          if(error.status == 401) this.router.navigateByUrl('/auth/patient-portal')
                        }, () => {
                        })                  


                }else{
                  this.toaster.ForDanger('Email Message Send Unsucessfull');
                }
               })
              }
              }else{
                this.toaster.ForDanger('Email Credit Balance is 0');
              }
        }

    }, (error) => {
      if(error.status == 401) this.router.navigateByUrl('/auth/patient-portal')
    }, () => {
    })
  
  
  }

    sendSMS(appointmentData, templateData, options) {
    let smstrackingDetails = {
      referencefrom: this.pageName+'-'+ options,
      referencenum: appointmentData.regId,
      mobileNumber: appointmentData.mobileNumber,
      dateTime: this.DatService.currentDate(),
      message: this.smscontent,
      smsUnit: 1,
      status: "ok",      
      senderId: templateData.smsServiceName,
      templateId: templateData.smsTemplateDetId,
      
      createdIp: null,
      // createdby: parseInt(localStorage.getItem("userId")),
      createddate: this.DatService.currentDate(),
      tenantId: this.superAdminTenant.tenantId,
      branchId: this.superAdminTenant.branchId
    }

    let smsContent = {
      text: this.smscontent,
      mobile: appointmentData.mobileNumber,
      tenantApiConfigId:templateData?.smsConfigId,
      commonSmsTempId:templateData.commonTempMstId,
      
      tenantId: this.superAdminTenant.tenantId,
      branchId: this.superAdminTenant.branchId,
      smstrackingDetails: smstrackingDetails
    }

    this.rolesService.create(`${environment.apiUrl}/sms/send`, smsContent).subscribe(data => {

        if(data.code === 200){
          this.toaster.ForSuccess('SMS Send Sucessfully');
        }else{
          this.toaster.ForDanger('SMS Send Unsucessfull');
        }

    }, (error) => {
      this.toaster.ForDanger('SMS Send Unsucessfull');
      if(error.status == 401) this.router.navigateByUrl('/auth/patient-portal')
    }, () => {
    });
  }



  onRequestPasswordClose(data: any): void {
    if (data == null) {
      this.isForgotPassword = false;
      this.isUserLogin = true;
    }
    else if (data.otpVerified == "approved" || data.otpVerified == "success") {
      this.isSuccess = true;
      this.otpForm.reset();
      this.isFailure = false;
      this.isLogin=false;
       this.forgetPass=false;
      this.mobileVerifyPopUp = false;
      this.resetMobileNum = data.resetMobileNum;
      this.isForgotPassword = false;

      this.isResetComp = true;
    }

  }


   loginCreate(): void {
    this.submitted=true;
    if (this.tenantAlias) {
      this.tenantResolved$.pipe(take(1), takeUntil(this.unsubscribe$)).subscribe(() => this.prepareLogin());
      return;
    }
    this.prepareLogin();
  }

  private prepareLogin(): void {
    if (this.tenantAlias) {
      // Care Navigator / Reviewer use this same mobile-number + password loginForm as Doctor/Patient.
      this.loginForm.controls["tenantId"].setValue(this.dynamicTenantId);
      this.loginForm.controls["branchId"].setValue(this.dynamicBranchId);
      // Mirrors CareLoginComponent.loginCreate(): doctor logins carry no country code,
      // patient logins use the tenant-resolved country - set regardless of whether the
      // mobileCountryCode control was already populated by resolveTenant().
      if (this.userType === 'doctor' || this.isEmployeeRole) {
        this.loginForm.controls["mobileCountryCode"].setValue(null);
      } else {
        this.loginForm.controls["mobileCountryCode"].setValue(this.countryId);
      }
    } else {
      this.loginForm.controls["tenantId"].setValue(environment.virtualTenant.toLowerCase());
      this.loginForm.controls["branchId"].setValue(environment.virtualBranch.toLowerCase());
    }
    this.user = { ...this.loginForm.value, rememberMe: this.loginForm.value.rememberMe || null };
    this.errors = [];
    this.messages = [];
    this.submitted = true;
    this.submitLogin();
  }

  private submitLogin(): void {
    const auth ={
      "fullName": "9500672785",
      "password": "Ezovion@1",
      "rememberMe": "",
      "tenantId": "6b5d5bf1-e369-4b5d-e9b3-08dacd6f38e4",
      "branchId": "4e54f59e-226b-42a3-8ef2-cda3ac8fc727"
  }
    // this.patSrvc.post(`auth/loginForMobile`,auth).subscribe((data)=> {      

    //   const det = data
    // })
    this.service.authenticate(this.tenantAlias ? 'wellspring' : 'email', this.user).subscribe((result: NbAuthResult) =>
    {
    // this.patSrvc.post(`auth/loginForMobile`,auth).subscribe((result)=> {
      this.loginResult =result;
      if (result.isSuccess()) {
        this.messages = result.getMessages();
        this.userAlreadyExists = false;

        // Wait for initCurrentUser() to finish writing employeeId/physicianId/tenantId/etc.
        // to localStorage before anything below reads them - this used to fire via a bare
        // .subscribe() (fire-and-forget) while the redirect logic ran immediately after on
        // the next line, so redirectAfterLogin()'s employee/doctor lookup could read a
        // still-unset employeeId/physicianId as null (404ing the Care Navigator/Reviewer
        // employee fetch with an "employee/null" URL) before the HTTP response landed.
        // `submitted` also deliberately stays true (Sign In button disabled) through this
        // whole chain now instead of being cleared immediately on auth success - clearing it
        // early let a fast double-click re-submit while this redirect was still resolving,
        // kicking off a second concurrent login/redirect chain that stepped on the first and
        // left the flow in a broken/half-navigated state.
        this.initUserService.initCurrentUser().subscribe(() => {
          if (this.tenantAlias) {
            // Tenant-based WellSpring Login: role-based redirect, mirrors CareLoginComponent.loginCreate().
            // SecondOpinionFlag was already derived from the resolved tenant's tenantType in
            // ngOnInit()'s resolveTenant() callback - nothing to (re)compute here.
            localStorage.setItem('WellSpringAppFlag', String(this.wellSpringAppFlag));
            localStorage.setItem('tenantAlias', this.tenantAlias);
            localStorage.setItem('SecondOpinionFlag', String(this.secondOpinionTenant));
            localStorage.setItem('userType', this.userType);
            localStorage.setItem('customerTenantLogo', this.customerTenantLogo);
            localStorage.setItem('customerName', this.customerName);
            // Also persist for the role-selector-card sign-in path (not just the invite-link
            // route, which already sets this in ngOnInit above) - PagesComponent.initMenu() and
            // OneColumnLayoutComponent.isCareNavigatorSession both key off this instead of
            // 'userType', since InitUserService.initCurrentUser() (just above) overwrites
            // 'userType' with the backend User record's own unrelated numeric value.
            if (this.isEmployeeRole) {
              this.employeeRoleUrlSuffix = this.userType;
              localStorage.setItem('employeeRoleUrlSuffix', this.userType);
            }
            this.tenantRoleLoginService.redirectAfterLogin(this.userType as 'doctor' | 'patient' | 'care-navigator' | 'reviewer', {
              tenantId: this.dynamicTenantId,
              branchId: this.dynamicBranchId,
              fullName: this.user.fullName,
              mobileCountryCode: this.isEmployeeRole ? null : this.loginForm.get('mobileCountryCode')?.value,
            }, (message) => this.handleUnauthorizedEmployeeRole(message));
            this.cd.detectChanges();
            return;
          }

          // No-tenant WellSpring App login has no tenant to fetch a banner logo from
          // (unlike the tenantAlias branch above's getTenantBanner() call), but the
          // sidebar's own logoSrc getter (one-column.layout.ts) still reads
          // customerTenantLogo from localStorage - without this, it was never set
          // here and fell through to the generic Ezovion logo instead of WellSpring's.
          if (this.wellSpringAppFlag) {
            localStorage.setItem('customerTenantLogo', this.customerTenantLogo);
          }

          var searchData={
            "searchWord": this.user.fullName,
            "fromDate": null,
            "toDate": null,
            "skip": 0,
            "take": 100
        };
          this.patSrvc.searchList("patientregistrationmst/" + environment.virtualTenant + '/' + environment.virtualBranch + '/search', searchData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
            const selected = data.find(x => x.country === this.loginForm.get('mobileCountryCode')?.value) || data[0];

                localStorage.setItem("loginuser","patientlogin");
                // Virtual-tenant Patient Portal flow - guard against a stale 'true'
                // left over from a prior CareSphere/well-spring-tenant login on this browser.
                localStorage.setItem("InsuranceFlag","false");
            localStorage.setItem("regID", selected.id);
                localStorage.setItem("patientMobNo",this.user.fullName);
            localStorage.setItem("patientName", selected.firstname);
            localStorage.setItem("patientCountryCode", selected.country);
            localStorage.setItem("age", selected.age?.toString());
                // Saved so pages that need the patient's real identity (e.g. the WellSpring
                // booking wizard's booking payload) can read it straight from localStorage
                // instead of re-fetching this same patientregistrationmst search again -
                // matches the 'gender'/'dob' keys tenant-role-login.service.ts/
                // care-login.component.ts already use for their own login flows.
                localStorage.setItem("gender", selected?.gender || '');
                localStorage.setItem("dob", selected?.dob || '');
                localStorage.setItem("patientFirstName", selected?.firstname || '');
                localStorage.setItem("patientMiddleName", selected?.middlename || '');
                localStorage.setItem("patientLastName", selected?.lastname || '');
                if(data[0]?.email){
                  localStorage.setItem('patientEmail', data[0]?.email);
                }
                this.submitted=false;
                // localStorage.setItem('countryCode', this.cc);
                // No-tenant WellSpring App login (plain OTP flow) also lands on the merged
                // well-spring-dashboard; the plain, non-WellSpring /auth/patient-portal login
                // keeps going to the standalone patient-landing page.
                return this.router.navigate([this.wellSpringAppFlag ? '/pages/well-spring/dashboard' : '/pages/patient-portal/landing']);
            });
          this.cd.detectChanges();
        });
      } else {
        this.submitted = false;
        // this.router.navigate(['auth/patient-portal']);
        if(result.getResponse().status == 403){
          this.errors.push("Your account has been disabled, Please see your administrator");
        }
        else{
          this.errors.push("Incorrect credentials. Try again.");
          // A WellSpring App session (with or without a tenant) must stay on the
          // WellSpring login route on failure - falling through to the plain
          // /auth/patient-portal route (below) would silently drop the user out
          // of the WellSpring flow they actually came from.
          if (this.tenantAlias) {
            // Stay on this same page/component instance to retry - do NOT navigate to this
            // same tenant URL here. Re-navigating (even to the identical URL) risked reloading
            // this component, re-running ngOnInit()'s localStorage.clear() and re-triggering the
            // async resolveTenant() call; a valid retry submitted before that finished would
            // read a stale/reset SecondOpinionFlag and wrongly land on the regular WellSpring
            // dashboard instead of the Second Opinion one. The error above is already visible,
            // and dynamicTenantId/branchId/SecondOpinionFlag are all still intact for the retry.
            this.cd.detectChanges();
            return;
          }
          if (this.wellSpringAppFlag) {
            return this.router.navigate(['/auth/well-spring-login']);
          }
          return this.router.navigate(['/auth/patient-portal']);
        }

        this.cd.detectChanges();
      }
    });
  }

  // The employee's real credentials were valid (NbAuth already succeeded), but
  // TenantRoleLoginService.redirectEmployeeRole() found their Employee_Mst.JobCategoryId
  // doesn't match the role they signed in as (e.g. Care Navigator requires 49) - clear the
  // session that login just created (mirrors NgxLogoutComponent's own clear-then-logout
  // order) and surface the reason inline, staying on this same page/component instance so
  // the tenant/employee-role state (dynamicTenantId, isEmployeeRole, etc.) is still intact
  // for a retry with different credentials.
  private readonly tenantSessionKeys = [
    'WellSpringAppFlag', 'SecondOpinionFlag', 'tenantAlias', 'employeeRoleUrlSuffix', 'tenantId',
    'branchId', 'tenantType', 'customerName', 'countryCode', 'responseTenantId',
  ];

  private handleUnauthorizedEmployeeRole(message: string): void {
    this.loginResult = null;
    this.messages = [];
    const tenantSession = this.tenantSessionKeys.map(k => [k, localStorage.getItem(k)] as [string, string | null]);
    localStorage.clear();
    tenantSession.forEach(([k, v]) => { if (v !== null) { localStorage.setItem(k, v); } });
    this.service.logout(this.strategy).subscribe(() => {
      this.submitted = false;
      this.employeeRoleError = message;
      this.cd.detectChanges();
    });
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    this.checkIsExists(event);
    return true;

  }
  checkIsExists(event){

    // Tenant-based WellSpring Login (Care Sphere role login) is a plain credential login, not the
    // patient-portal signup flow this "does this number already belong to a patient" check is
    // for - bookingPlatform/checkIsPatientExists isn't tenant/role-aware and can error here,
    // which (since the input is only re-enabled in the observable's complete callback) leaves
    // the mobile number field permanently disabled. Skip it entirely for the tenant flow.
    if (this.tenantAlias) {
      return;
    }

    if(event.target.value.length>=this.mobileMinlength && event.target.value.length<=this.mobileMaxlength){
      let data={
        "PatientMobile":event.target.value,
        "countryId": (this.isLogin) ? this.loginForm.get('mobileCountryCode')?.value : this.bookingPlatFormApp.get('mobileCountryCode')?.value
      }
      event.target.disabled = true;
      this.getDrAppointmentService.searchList(`bookingPlatform/checkIsPatientExists`, data).pipe(takeUntil(this.unsubscribe$)).subscribe(returnData => {
       
        this.patientLists = [];
        this.userList = [];
         const formControlsToUpdate = ['firstName','lastName','dob', 'gender','title'];
          formControlsToUpdate.forEach(key => {
            this.bookingPlatFormApp.controls[key]?.reset();
            this.bookingPlatFormApp.controls[key]?.enable();
          });
        
        // Check if the patient alone exists
        if (returnData.patient.length !== 0 && returnData.user == null) {
          this.patientDetails = returnData?.patient;
           this.bookingPlatFormApp.get('firstName')?.setValue(this.patientDetails[0]?.firstname);
            this.bookingPlatFormApp.get('firstName')?.disable();
           this.bookingPlatFormApp.get('lastName')?.setValue(this.patientDetails[0]?.lastname);
            this.bookingPlatFormApp.get('lastName')?.disable();
            this.bookingPlatFormApp.get('email')?.setValue(this.patientDetails[0]?.email);
            this.bookingPlatFormApp.get('email')?.disable();
          const formControlsToUpdate = ['gender','title'];
           if( this.patientDetails[0]?.dobFlag =='N' ){
                   this.bookingPlatFormApp.get('dob')?.setValue(this.patientDetails[0]?.ageResult);
           }
           else{
                    this.bookingPlatFormApp.get('dob')?.setValue(this.patientDetails[0]?.dob);          
           }
           this.bookingPlatFormApp.get('dob')?.disable();
          formControlsToUpdate.forEach(key => {
            this.bookingPlatFormApp.controls[key]?.setValue(this.patientDetails[0]?.[key]);
            this.bookingPlatFormApp.controls[key]?.disable();
          });
              
          this.userAlreadyExists = false;
        }
        // Check if both patient and user exist
        else if (!!returnData.patient && returnData.user != null) {
          if(!this.isLogin){
            this.isLogin=true;
            this.userAlreadyExists = true;
          }
          // this.openLoginPopup = true;
          this.signUp = false;
          this.loginForm.get('fullName').setValue(event.target.value);
          this.patientLists = returnData.patient;
          this.userList = returnData.user;
        } 
        //when neither patient nor user exist
        else {
          this.userAlreadyExists = false;
          // this.openLoginPopup = false;
         // this.customer = false;
         this.bookingPlatFormApp.get('firstName')?.enable();
         this.bookingPlatFormApp.get('lastName')?.enable();
         this.bookingPlatFormApp.get('dob')?.enable();
        //  this.bookingPlatFormApp.get('gender')?.enable();

        if(this.isLogin){
          this.toaster.ForDanger('No account found with this mobile number. Please sign up to continue.');
        }
        }}, (error) => {
        // Re-enable here too - the observable errors out and never completes, so relying only
        // on the complete callback below left the field permanently disabled on any API failure.
        event.target.disabled = false;
      }, () => {
        event.target.disabled = false;
      });
    }
    
      }

      saveAppBooking(fromLogin?){
        this.isSubmitted=true;
        if(this.bookingPlatFormApp.valid && this.bookingPlatFormApp?.get('pass')?.value === this.bookingPlatFormApp?.get('confirmPass')?.value || !!fromLogin){
          // this.isSubmitted=true;
          let newData=new Date( this.bookingPlatFormApp.get('dob').value);
          const today = new Date();
      
          var Difference_In_Time = Math.abs(Date.now() - newData.getTime());
          var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));
          var ageValue = Difference_In_Days / 365.25;
          const year = (Math.round(ageValue));
          this.userName = this.bookingPlatFormApp.get('firstName').value;
          this.userMobileNumber = this.bookingPlatFormApp.get('mobile').value
          const fullname=this.bookingPlatFormApp.get('firstName').value+(this.bookingPlatFormApp.get('lastName').value ?''+this.bookingPlatFormApp.get('lastName').value:'');
          this.selectedCC = this.countryCodeDropDownLists.find(c => c.id === this.bookingPlatFormApp.get('mobileCountryCode')?.value)?.countryCode
          let requestData ={
              branchId: this.tenantAlias ? this.dynamicBranchId : environment.virtualBranch,
              email: this.bookingPlatFormApp.get('email').value,
              fName:  this.bookingPlatFormApp.get('firstName').value,
              lName: null,
              mobileNum: this.bookingPlatFormApp.get('mobile').value,
              tenantId: this.tenantAlias ? this.dynamicTenantId : environment.virtualTenantID,
              fullName: fullname,
              userFlag: "Patient",
              title: this.bookingPlatFormApp.get('title').value,
              gender: this.bookingPlatFormApp.get('gender').value,
              age: year,
              loginUserType: "patientlogin",
              password: this.bookingPlatFormApp.get('pass').value,
              confirmPassword: this.bookingPlatFormApp.get('confirmPass').value,
              CountryId:this.bookingPlatFormApp.get('mobileCountryCode')?.value,
              mobileCountryCode: this.selectedCC,
              dob:this.bookingPlatFormApp.get('dob').value
            }

            if( this.patientDetails && this.patientDetails.length >0 ){
              requestData ={
                ...requestData,
                ...{
                dobFlag: this.patientDetails[0]?.dobFlag,
                ageResult: this.patientDetails[0]?.ageResult}
              }

              if( this.patientDetails[0]?.dobFlag=='N' ){
                requestData.dob=null;
              }
            }

            // WellSpring / Second Opinion (tenant login) registers through virtual-patient-registration,
            // which takes the tenant/branch GUIDs and always answers 200 with { status, message, regId }.
            const signUpUrl = this.tenantAlias ? '/auth/wellspring-virtual-patient-registration' : '/auth/sign-upForMobile';
            let signUpRejected = false;
            this.http.post(environment.apiUrl + signUpUrl, requestData).subscribe((res: any) => {
              if (this.tenantAlias && res?.status === false) {
                signUpRejected = true;
                this.toaster.ForDanger(res.message || 'Unable to register. Please try again.');
                return;
              }
              // WellSpring: mobile number already registered -> show message and open Login
              if (this.tenantAlias && res?.message === 'Patient Already Exists') {
                signUpRejected = true;
                this.userList = { firstName: requestData.fName } as any;
                this.userAlreadyExists = true;
                this.signUp = false;
                this.isLogin = true;
                this.isSubmitted = false;
                this.loginForm.get('fullName').setValue(requestData.mobileNum);
                return;
              }
              this.isAppointmentSaved=true;
              this.signUp=false;     
              if(Object.keys(this.assesmentData).length > 0){ 
                const asses= JSON.parse( this.assesmentData?.inputJson || '{}');

                if( (asses?.ageCategory==1 && year>17 ) || (asses?.ageCategory==2 && (year<18 || year>64) ) || (asses?.ageCategory==3 && year<65) ){
                      this.assesPopUpForAgeMismatch=true;
                }
                else{
              this.storeAssesmentData(res.regId);}
            }    
            this.isAssesment=false;
            this.isAppointmentBooking = false;
            this.page="signup";
            this.loginForm.get('fullName').setValue(requestData.mobileNum);
            this.loginForm.get('password').setValue(requestData.password);
            this.loginForm.get('mobileCountryCode')?.setValue(requestData.CountryId);  
            this.isSubmitted=false;
            this.errors = [];
              setTimeout(()=>{ this.isAppointmentSaved=false;},4000)
          },(error)=>{
            if (this.tenantAlias) {
              // Tenant login: stay on the sign-up popup and show the error - no redirect.
              this.toaster.ForDanger(error?.error?.message || 'Unable to register. Please try again.');
            } else if(error.status==401){
              this.router.navigateByUrl('/auth/patient-portal');
            }
          },()=>{
            if (signUpRejected) { return; }
            if(requestData?.email) this.patientEmail = requestData?.email;
            this.checksmspossibility("confirmation")
          })
        }

     
       
      }

      popupClose(){
        this.assesPopUpForAgeMismatch=false;
      }

      focustoOpenSelect($event){ 
        $event.optionsOpen()
      }
      tabToClose($event){
        $event.optionsClose()
      }
      onTitleChange(event: INgxSelectOption[]) {
        if(event){
                  if (event[0]?.data?.value == "1" || event[0]?.data?.value == "5") {
          this.bookingPlatFormApp.controls['gender'].setValue("Male");
        }
        else if (event[0]?.data?.value == "2" || event[0]?.data?.value == "3" || event[0]?.data.value == "4") {
          this.bookingPlatFormApp.controls['gender'].setValue("Female");
        }
        this.bookingPlatFormApp.get('gender').disable();  
      }
    }
      openLogin(){
        // this.loginForm.get('fullName').setValue(this.bookingPlatFormApp.get('mobile').value);
        this.isLogin=true;
        this.signUp=false;
        this.isSubmitted=false;
        this.loginForm.get('fullName').reset();
        this.loginForm.get('password').reset();
      }

      loadCountryMaster(): void {
        this.patAptSrv.list(`countries/getCountryMasterAnonymous`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
          this.countryCodeDropDownLists = data.details.filter(x => x.countryCode != null);
          
        }, (error) => {
          if(error.status==401){
            this.router.navigateByUrl('/auth/patient-portal');
          }
        }, () => {
          this.signUp = true;
        this.bookingPlatFormApp.reset();
        this.invalidbookingPlatFormAppForm = false;
        const tenantCountry = this.tenantAlias
          ? (this.countryCodeDropDownLists.find(x => x.id === this.countryId)
            || this.countryCodeDropDownLists.find(x => x.countryCode == localStorage.getItem('countryCode')))
          : undefined;
        const countryCode = tenantCountry ? [tenantCountry] : this.countryCodeDropDownLists.filter(x => x.countryCode == this.cc);
        if(countryCode.length>0){
          this.bookingPlatFormApp.get('mobileCountryCode')?.setValue(countryCode[0]?.id);
        }
        });
      }

      onCountryCodeChange(code , type) {
        if(type=='Mobile'){
            this.mobileMinlength = code[0]?.data?.minMobileNumberLength ;
            this.mobileMaxlength = code[0]?.data?.maxMobileNumberLength ;
            this.bookingPlatFormApp.get('mobile').setValidators([Validators.minLength(this.mobileMinlength) , Validators.maxLength(this.mobileMaxlength)]);
            this.bookingPlatFormApp.get('mobile').updateValueAndValidity(); 
        }}


  onClickProfile(){
    this.errors = [];
    this.loginForm.reset();
    this.isAssesment=false;
    this.isAppointmentBooking = false;
    this.page="signup";
    this.loadCountryMasterForLogin();
  }

  loadCountryMasterForLogin(): void {
    this.patAptSrv.list(`countries/getCountryMasterAnonymous`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.countryCodeDropDownLists = data.details.filter(x => x.countryCode != null);
      
    }, (error) => {
      if(error.status==401){
        this.router.navigateByUrl('/auth/patient-portal');
      }
    }, () => {

      const countryCode = this.countryCodeDropDownLists.filter(x => x.countryCode == this.cc);
      if(countryCode.length>0){
        this.mobileMinlength = countryCode[0]?.minMobileNumberLength ;
        this.mobileMaxlength = countryCode[0]?.maxMobileNumberLength ;
        this.loginForm.get('mobileCountryCode')?.setValue(countryCode[0]?.id);
        localStorage.setItem('selectedCountryId',countryCode[0]?.id)
      }
    });
  }

  gotoHome(){
    this.page="location";
    this.isAppointmentBooking = false;
    this.isAssesment=false;
  }

  goToAssesment(){
    this.page='';
    this.isAppointmentBooking = false;
    this.isAssesment=true;
  }


  callSignUpPage(event){
    this.isLogin=false;
    this.assesmentData=event;
    this.onCreateAccount();
  }

  onClickCountry(countryName){
    this.countryName = countryName;
    this.setCountryCode();
  }

  setCountryCode(){
    this.rolesService.list(`countries/GetCountryByName/${this.countryName}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        if(!!data){
          this.cc =data?.countryCode;
          this.bookingPlatFormApp.get('mobileCountryCode')?.setValue(data?.countryCode);
          this.mobileMinlength = data?.minMobileNumberLength;
          this.mobileMaxlength = data?.maxMobileNumberLength;
          this.bookingPlatFormApp.get('mobile')?.setValidators([
            Validators.required,
            Validators.minLength(data?.minMobileNumberLength),
            Validators.maxLength(data?.maxMobileNumberLength)
          ]);
          this.bookingPlatFormApp.get('mobile')?.updateValueAndValidity();
        }
      },(error)=>{
        if(error.status==401){
          this.router.navigateByUrl('/auth/patient-portal');
        }
      },()=>{
      })
  }


  onCreateAccount(){
    // this.isLogin = true;
    this.userAlreadyExists = false;
    this.loadCountryMaster();
  }

  onClickClose(){
    this.errors = [];
    this.isLogin = true;
    this.signUp = false;
    this.bookingPlatFormApp.reset();
    this.invalidbookingPlatFormAppForm = false;
  }

  storeAssesmentData(regId){
      this.assesmentData.regId=regId;
      this.assesmentData.createdDate=new Date();
      this.rolesService?.create(`${environment.apiUrl}/PatientAssessment/postPatientAssessment`, this.assesmentData).pipe(takeUntil(this.unsubscribe$)).subscribe(
        (data: any) => {
          if (data && data.details ) {
            this.assesmentData={};
          }
        }      
      )
    
  }


  toLowerCase(event: any) {
    event.target.value = event.target.value.toLowerCase();
  } 
  getImagePath(deptName) {
    const imagePath = "assets/images/pportal/Icons/";
  
    const map = {
      Cardiology: 'Cardiology.svg',
      Dental: 'Dental.svg',
      Dermatology: 'Dermatology.svg',
      Diabetes: 'Diabetes.svg',
      Diet: 'Diet.svg',
      ENT: 'ENT.svg',
      Eye: 'Eye.svg',
      Footcare: 'Foot Care.svg',
      Gastroenterology: 'Gastro.svg',
      'General Medicine': 'General.svg',
      Gynaecology: 'Gynaecology.svg',
      Homeopathy: 'Homeopathy.svg',
      Nephrology: 'Nephrology.svg',
      Neurology: 'Neurology.svg',
      'Nutrition Theraphy': 'Nutrition-therapy.svg',
      Obstetrics: 'Obstetrics.svg',
      Orthopedics: 'Orthopedics.svg',
      Paediatric: 'Paediatric.svg',
      Physiotheraphy: 'Physiotherapy.svg',
      Podiatry: 'Podiatry.svg',
      Prevention: 'Prevention.svg',
      Psychology: 'Psychology.svg',
      Urology: 'Urology.svg',
      Vascular: 'Vascular.svg',
      Woundcare: 'Woundcare.svg',
      Vaccination:'Vaccination.svg'
    };
  
    return imagePath + (map[deptName] || 'Others.svg');
  }
  
}
